import { render, staticRenderFns } from "./epg-simple.vue?vue&type=template&id=9a4d4d78"
import script from "./epg-simple.vue?vue&type=script&lang=js"
export * from "./epg-simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports